// path: src/utils/cardImages.js

import { getBaseCorgiImagePath } from "./cardCatalog";

/**
 * Characters.json stores paths like "../images/1-100/0001.png".
 * Convert those to a browser URL under PUBLIC_URL / site root.
 */
export function getCardImageSrc(card) {
    if (!card || card.image == null) {
        return "";
    }

    const raw = String(card.image).trim();
    if (!raw) {
        return "";
    }

    if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) {
        return raw;
    }

    // Legacy callers used `imgs/${card.image}` which resolves ../images/... → /images/...
    const normalized = raw.replace(/^\.\.\//, "").replace(/^\//, "");
    const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
    return `${publicUrl}/${normalized}`;
}

export { getBaseCorgiImagePath };
